import { EntityService } from './EntityService';
import { IEntity, IGoDefElement } from '../types';

export class GoDefElementService extends EntityService<IGoDefElement> {
    public readonly parentEntities = [];
    protected childrenEntities = ['GoDefElementOrgLevel1s'];

    constructor() {
        super(`/GoDefElements`);
    }

    public readAllWithFilters(goFormId: number | string, level1ID: number, incompleteOnly: boolean, justMine: boolean): Promise<IEntity[]> {
        return this.readAll(`?goFormId=${goFormId}&level1ID=${level1ID}&incompleteOnly=${incompleteOnly}&justMine=${justMine}`);
    }

    public readAllForDefnList(): Promise<IGoDefElement[]> {
        return this.readAll(
            `?$select=ID,Title`
            + `&$expand=GoDefElementOrgLevel1s($expand=OrgLevel1($select=Title))`
            + `&$orderby=Title`
        );
    }
}